module.exports = __webpack_public_path__ + "img/img04.d2d40b55.png";